export const BORDER_RADIUS = 10;
export const MAX_UPGRADE_LENGTH = 1900;
export const MAX_CREATE_LENGTH = 900;
